import { createEvent, createStore, sample } from 'effector';
import { loginFx, restoreSessionFx } from '../session/model';
import { fetchTenantConfigFx } from '../tenant/model';
import type { Session } from '../session/types';

/** Shell вызывает один раз при старте приложения */
export const appStarted = createEvent<void>();

/** true, пока не завершилась попытка восстановления сессии */
export const $bootstrapPending = createStore<boolean>(true).on(
  restoreSessionFx.finally,
  () => false,
);

// Старт → восстановление сессии из localStorage
sample({ clock: appStarted, target: restoreSessionFx });

// Есть сессия (восстановлена или логин) → грузим конфиг тенанта
sample({
  clock: [restoreSessionFx.doneData, loginFx.doneData],
  filter: (session: Session | null): session is Session => session !== null,
  fn: (): void => undefined,
  target: fetchTenantConfigFx,
});
